import { StorageSerializers, useSessionStorage, type RemovableRef } from '@vueuse/core';
import { defineStore } from 'pinia';

import type { ReturnCase, WarrantyCase } from '@/types/case.interface';
import type { CaseType } from '@onrunning/backstage-models';

export interface State<T extends WarrantyCase | ReturnCase> {
  caseOrder: T | null;
  caseUpdated: RemovableRef<boolean>;
  caseType: RemovableRef<CaseType | undefined>;
  updatedCaseOrder: RemovableRef<T | null>;
}

export const useCaseStore = defineStore('case', {
  state: (): State<WarrantyCase | ReturnCase> => ({
    caseOrder: null,
    caseUpdated: useSessionStorage('case/caseUpdated', false),
    caseType: useSessionStorage('case/caseType', undefined),
    updatedCaseOrder: useSessionStorage('case/updatedCaseOrder', null, {
      serializer: StorageSerializers.object,
    }),
  }),

  actions: {
    setCase(caseOrder: WarrantyCase | ReturnCase) {
      this.caseOrder = caseOrder;
    },

    setCaseType(caseType: CaseType | undefined) {
      this.caseType = caseType;
    },

    setUpdatedCase(caseItem: WarrantyCase | ReturnCase) {
      this.updatedCaseOrder = caseItem;
      this.caseUpdated = true;
    },

    setUpdateStatus(status: boolean) {
      this.caseUpdated = status;
    },

    reset() {
      this.caseOrder = null;
      this.caseUpdated = false;
      this.caseType = undefined;
      this.updatedCaseOrder = null;
    },
  },
});
